import { LovOption, LovOrderingMode } from "../api/contracts";

export function formatLovSelectionType(selectionType: string): string {
  switch (selectionType.trim().toLowerCase()) {
    case "single":
      return "Single Select";
    case "multi":
      return "Multi Select";
    default:
      return selectionType || "Not provided";
  }
}

export function formatLovOrderingMode(orderingMode: LovOrderingMode): string {
  return orderingMode === "alphabetical" ? "Alphabetical" : "Fixed order";
}

const lovNameCollator = new Intl.Collator(undefined, {
  sensitivity: "base",
});

export function sortLovOptions(
  options: readonly LovOption[],
  orderingMode: LovOrderingMode,
): LovOption[] {
  return options
    .map((option, index) => ({ option, index }))
    .sort((left, right) => {
      const nameComparison = lovNameCollator.compare(
        left.option.name,
        right.option.name,
      );
      const configuredComparison =
        orderingMode === "fixed"
          ? left.option.sortOrder - right.option.sortOrder || nameComparison
          : nameComparison;
      return configuredComparison || left.index - right.index;
    })
    .map(({ option }) => option);
}
